import React, {FC} from "react";
import {Alert} from "antd";
import {useGetBookingDunningStatusesQuery, useGetCompanyInfoQuery} from "../../../../generated/graphql";
import i18n from "../../../../services/i18n";

// Getter statt Modul-Konstante (react-hot-loader, siehe BookingDunningsPanel)
const tr = () => i18n.containers.invoice.BookingDunnings;

/** Sammel-Umbuchung (#1517): wie viele der Buchungen gemahnt sind; deren Mahnungen werden durch das Storno hinfällig */
const BulkDunningAlert: FC<{bookingIds: Array<string>}> = ({bookingIds}) => {
    const {data: company} = useGetCompanyInfoQuery({fetchPolicy: "cache-first"});
    const enabled = Boolean(company?.companyInfo?.subscription?.featureDunning);
    const {data} = useGetBookingDunningStatusesQuery({variables: {bookingIds}, skip: !enabled || bookingIds.length === 0, fetchPolicy: "network-only"});
    const count = (data?.bookingDunningStatuses ?? []).filter((status) => status.level).length;

    if (count === 0) {
        return null;
    }

    return <Alert type="info" showIcon style={{marginBottom: 12}} message={tr().bulk.title({count: String(count)})} description={tr().bulk.text()} />;
};

export default BulkDunningAlert;
